import type { ArtnightUSPSParams, ArtnightUSPSReturn, USPCardParams, USPCardReturn } from '../types';
import { formatUSPCardTextContent } from '../helpers';

export default function (params: ArtnightUSPSParams): ArtnightUSPSReturn {
  const { _editable, _uid, backgroundColor, title, uspCards } = params;

  return {
    module: 'SArtnightUSPs',
    _uid,
    backgroundColor,
    title: formatUSPCardTextContent(title[0]),
    uspCards: uspCards.map(
      (item: USPCardParams): USPCardReturn => ({
        component: item.component,
        module: 'SUspCard',
        _editable: item._editable,
        _uid: item._uid,
        borderRadius: item.borderRadius,
        backgroundColor: item.backgroundColor,
        title: formatUSPCardTextContent(item.title[0]),
        text: formatUSPCardTextContent(item.text[0])
      })
    )
  };
}
